import React from 'react';
import { motion } from 'framer-motion';
import { Target } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const audiences = [{
  title: 'Mentes estancadas y saturadas:',
  desc: 'Personas que repiten los mismos patrones diarios y se sienten atrapados en una victimización silenciosa.'
}, {
  title: 'Quienes buscan resultados desde casa:',
  desc: 'Sin necesidad de terapias interminables, adaptando hábitos básicos y eliminando estímulos tóxicos desde hoy.'
}, {
  title: 'Líderes y profesionales:',
  desc: 'Personas bajo mucha presión que necesitan herramientas de choque efectivas para no perder el control de sus decisiones.'
}, {
  title: 'Buscadores de claridad:',
  desc: 'Personas decididas a hackear su rutina diaria, recuperar la concentración y el control de su tiempo.'
}];
export function TargetAudience() {
  return <section className="py-24 px-6 border-b border-ink/10 bg-bone-dark/30" data-id="element-153">
      <div className="max-w-editorial mx-auto" data-id="element-154">
        <SectionHeader number="03" title="🎯 ¿PARA QUIÉN ES ESTO?" subtitle="Este sistema fue diseñado exclusivamente para personas que quieren transicionar del caos a la dirección clara:" data-id="element-155" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12" data-id="element-156">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bone border border-ink/10 p-8 rounded-sm hover:border-ink/20 transition-colors" data-id="element-157">
              <div className="mb-4" data-id="element-158">
                <Target size={24} className="text-oxblood" data-id="element-159" />
              </div>
              <h4 className="text-xl font-serif text-ink mb-3" data-id="element-160">{item.title}</h4>
              <p className="text-ink-light font-sans leading-relaxed" data-id="element-161">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}